export default __webpack_public_path__ + "static/media/hov_shape_L.e16f0a5e.svg";